import { FC, HTMLProps } from 'react';

import { sortFields } from 'constants/sortFields';
import { i18n as I18n } from 'utils/i18n';

export type SortOption = keyof typeof sortFields;

interface Props extends HTMLProps<HTMLSelectElement> {
  label?: string;
  sortOptions?: SortOption[];
}

const SortDropDown: FC<Props> = ({
  label = I18n.t('sort_by'),
  sortOptions = Object.keys(sortFields),
  ...props
}) => {
  return (
    <div className="sort-dropdown">
      <div className="sort-dropdown__select">
        <select name="select-sort-option" aria-label={label} {...props}>
          {sortOptions.map(field => (
            <option key={field} value={field}>
              {field}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SortDropDown;
